import { FC } from "react";
import * as _ from "lodash";

import { Typography, CtraLayout } from "@ctra/components";
import { parseLocoTemplate, useTranslation, Enterprise as Content } from "@ctra/i18n";

import { redirectURL } from "../../../../utils/url";
import { CookieKeys, Cookies } from "@ctra/utils";

const { ContentWrapper } = CtraLayout;
const { Title, Paragraph, Link } = Typography;

/**
 * No farms widget
 * @return {JSX.Element}
 * @constructor
 */
export const NoFarmsWidget: FC = () => {
  const { t } = useTranslation();

  const {
    overview: { noFarms }
  } = Content;

  const [title, p1, p2, li1, li2, p3a, p3b] = _.defaultTo(parseLocoTemplate(t<string>(noFarms), true), []);

  return (
    <ContentWrapper>
      <Title level={6}>{title}</Title>
      <Paragraph>{p1}</Paragraph>
      <Paragraph>{p2}</Paragraph>
      <ul>
        <li>{li1}</li>
        <li>{li2}</li>
      </ul>
      <Paragraph>
        {p3a}{" "}
        <Link
          onClick={() => {
            Cookies.set(CookieKeys.referrer, "platform");
          }}
          href={redirectURL}
        >
          {p3b}
        </Link>
      </Paragraph>
    </ContentWrapper>
  );
};
